import {useEffect, useRef, useState} from 'react'
import dayjs from 'dayjs'
import http from '@/biz/http.mjs'
import {createPlugin} from '@/components/MindMap/index.mjs'
import {publish, subscribe, unsubscribe} from '@/script/event.mjs'

export default () => {
    const refReport = useRef()

    const extensions = () => ({
        get isAvailable() {
            const {mapTypeCode} = this.data
            return /^_(BD|UI)_MAP$/.test(mapTypeCode)
        },

        get report() {
            return refReport.current
        },

        set report(report) {
            refReport.current = report
            publish(this, 'syntax_report_change', report)
        },

        async batchCheck({prjId, ssCode, sVer}) {
            await http.post(
                '/BODAStatement/check',

                {
                    bizMap: {prjId, ssCode, sVer},
                    checkKey: `${prjId}_${sVer}_${ssCode}`,
                    checkType: 'SS_BD_AND_UI',
                }
            )
        },

        async check() {
            const {mapTypeCode} = this.data

            const bizNodeTypes = {
                _BD_MAP: ['BD_RULE', 'BDLOGIC_RULE', 'BDLOGIC_TARGET'],
                _UI_MAP: ['ALG_RULE'],
            }[mapTypeCode]

            if (! bizNodeTypes) {
                return
            }

            const nodes = bizNodeTypes.map(
                bizNodeType => this.queryNodes({
                    all: true,
                    isMounted: true,
                    data: {bizNodeType},
                })
            ).flat()

            const items = nodes.map(n => {
                const _n = this.nodeProxy(n)
                const tree = _n.exportTree()
                const nodePath = `/${_n.getPathRaw()}`
                return {nodePath, syntaxTree: tree.children}
            })

            const result = await http.post('/BODAStatement/checkSignle', items)

            const errors = result.map(({
                checkMessage,
                checkNodePath,
            }) => ({
                key: crypto.randomUUID(),
                message: checkMessage,
                path: checkNodePath,
            }))

            const message = 0 < errors.length ?
                '检查到有不符合语句规范的内容，请根据报告明细进行修改！'
                :
                '语句规范性检查通过'

            const startTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
            this.syntax.report = {errors, message, startTime}
        },

        async fetchReport() {
            const {pkid, prjId, ssCode, sVer} = this.root.data

            const report = await http.get(
                '/BODAStatementCheckReport/latestBODAStatementCheckReportByDp',

                {
                    checkType: 'SS_BD_AND_UI',
                    checkKey: `${prjId}_${sVer}_${ssCode}`,
                    checkDpId: pkid,
                }
            )

            if (! report) {
                return report
            }

            const {
                bodaStatementCheckReportDetails,
                outParameter: message,
                startTime,
            } = report

            const errors = bodaStatementCheckReportDetails.map(({
                checkMessage,
                checkNodePath,
                pkid,
            }) => ({
                key: pkid,
                message: checkMessage,
                path: checkNodePath,
            }))

            this.syntax.report = {errors, message, startTime}
        },

        useReport() {
            const [report, setReport] = useState(this.syntax.report)

            useEffect(
                () => {
                    subscribe(this, 'syntax_report_change', setReport)

                    return () => {
                        unsubscribe(this, 'syntax_report_change', setReport)
                    }
                },

                []
            )

            return report
        },
    })

    const watchers = {
        load() {
            this.syntax.fetchReport()
        },
    }

    return createPlugin('syntax', {extensions, watchers})
}
